// import React, { useEffect, useState } from "react";
// import { Tooltip, Modal, Box, Typography, CircularProgress } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import moment from "moment/moment";
// import staffService from "../../../Services/staffService";


// const Staff = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const getStaff = async () => {
//       try {
//         setLoading(true);
//         const response = await staffService.fetchAll();
//         console.log(response);
//         setPatients(response.staffs);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching doctors');
//       }
//     };
//     getStaff();
//   }, []);

//   useEffect(() => {
//     const filteredResult = patients?.filter(
//       (item) =>
//         item?.full_name?.toLowerCase().includes(searchData.toLowerCase())
//     ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleViewClick = (doctor) => {
//     setSelectedDoctor(doctor);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedDoctor(null);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Doctors</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">{filteredData?.length || 0} records found</h1>
        
//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <Link to='AddEditStaff'>
//             <button className="bg-[#232233] h-[2rem] px-4 rounded-md text-white font-[600] text-[14px]">
//               + New Staff
//             </button>
//           </Link>
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%]">
//             <thead>
//               <tr className="text-[#101418] capitalize leading-normal text-sm">
//               <th className="py-[1%] w-[10%]  text-gray-700 text-left pl-4">Sr No.</th>
//               <th className="py-[1%] w-[20%]  text-gray-700 text-left pl-4">Full Name</th>
//                 <th className="py-[1%] w-[10%]  text-gray-700 text-left pl-4">Designation</th>
//                 <th className="py-[1%] w-[10%]  text-gray-700 text-left">Qualification</th>
//                 <th className="py-[1%] w-[20%]  text-gray-700 text-center">Address</th>
//                 <th className="py-[1%] w-[20%]  text-gray-700 text-center">Date of Appointment</th>
//                 <th className="py-[1%] w-[10%]  text-gray-700 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr key={patient?.patient_id} className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200">
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600 text-center">{patient?.staff_id}</p>
//                   </td>
//                   <td className="w-[20%] text-left">
//                     <p className="font-[600] text-gray-600 text-left">{patient?.full_name}</p>
//                   </td>
//                   <td className="py-[1%] w-[10%] text-left pl-4">
//                     <p className="font-[600] text-gray-600">{patient?.role}</p>
//                   </td>
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600">{patient?.qualification}</p>
//                   </td>
//                   <td className="py-[2%] px-2 w-[20%] text-center">
//                     <span className="font-[400]">{patient?.address}</span>
//                   </td>
//                   <td className="py-[2%] px-2 w-[20%] text-center">
//                     <span className="font-[400]">{moment(patient?.hire_date).format("ll")}</span>
//                   </td>
                
//                    <td className="py-[2%] w-[10%] text-center">
//                     <button
//                       onClick={() => handleViewClick(patient)}
//                       className="text-[13px] font-[500] text-blue-500"
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           data={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>

//       {/* <DoctorDetailsModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         doctorDetails={selectedDoctor}
//       /> */}
//     </div>
//   );
// };

// export default Staff;




import React, { useEffect, useState } from "react";
import { Modal, Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import moment from "moment/moment";
import staffService from "../../../Services/staffService";

const Staff = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const getStaff = async () => {
      try {
        setLoading(true);
        const response = await staffService.fetchAll();
        setPatients(response.staffs);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching staff");
      }
    };
    getStaff();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.full_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const handleViewClick = (doctor) => {
    setSelectedDoctor(doctor);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDoctor(null);
  };

  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">Staff Table</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        <div className="flex items-center gap-3">
          {/* Search */}
          <div className="relative">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by name..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          <Link to="AddEditStaff">
            <button className="bg-gray-800 hover:bg-gray-700 text-white text-[13px] px-4 py-[7px] rounded-lg">
              + New Staff
            </button>
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">Sr No.</th>
              <th className="py-3 px-4 text-left">Full Name</th>
              <th className="py-3 px-4 text-left">Designation</th>
              <th className="py-3 px-4 text-left">Qualification</th>
              <th className="py-3 px-4 text-center">Address</th>
              <th className="py-3 px-4 text-center">Date of Appointment</th>
              <th className="py-3 px-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="py-10 text-center text-gray-400 text-[13px]">
                  Loading...
                </td>
              </tr>
            ) : paginatedData?.length === 0 ? (
              <tr>
                <td colSpan={7} className="py-10 text-center text-gray-400 text-[13px]">
                  No records found
                </td>
              </tr>
            ) : (
              paginatedData?.map((patient) => (
                <tr
                  key={patient?.staff_id}
                  className="border-t hover:bg-gray-50 text-[13px]"
                >
                  <td className="py-3 px-4">{patient?.staff_id}</td>
                  <td className="py-3 px-4 font-[500]">{patient?.full_name}</td>
                  <td className="py-3 px-4">{patient?.role}</td>
                  <td className="py-3 px-4">{patient?.qualification}</td>
                  <td className="py-3 px-4 text-center">{patient?.address}</td>
                  <td className="py-3 px-4 text-center">
                    {moment(patient?.hire_date).format("ll")}
                  </td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleViewClick(patient)}
                      className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
      />

      {/* VIEW DETAIL MODAL */}
      <Modal open={isModalOpen} >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 480,
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 0,
            overflow: "hidden",
          }}
        >
          {/* Modal Header */}
          <div className="bg-gray-800 px-6 py-4 flex items-center justify-between">
            <Typography className="!text-white !text-[16px] !font-semibold">
              Staff Details
            </Typography>
            <button
              onClick={handleCloseModal}
              className="text-gray-300 hover:text-white text-[20px] leading-none"
            >
              &times;
            </button>
          </div>

          {/* Modal Body */}
          {selectedDoctor && (
            <div className="px-6 py-5 flex flex-col gap-4">

              <div className="flex justify-between border-b pb-3">
                <span className="text-[13px] text-gray-500 font-medium">Staff ID</span>
                <span className="text-[13px] text-gray-800 font-semibold">{selectedDoctor.staff_id}</span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-[13px] text-gray-500 font-medium">Full Name</span>
                <span className="text-[13px] text-gray-800 font-semibold">{selectedDoctor.full_name}</span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-[13px] text-gray-500 font-medium">Designation</span>
                <span className="text-[13px] text-gray-800">{selectedDoctor.role}</span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-[13px] text-gray-500 font-medium">Qualification</span>
                <span className="text-[13px] text-gray-800">{selectedDoctor.qualification}</span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-[13px] text-gray-500 font-medium">Address</span>
                <span className="text-[13px] text-gray-800 ml-20">{selectedDoctor.address}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-[13px] text-gray-500 font-medium">Date of Appointment</span>
                <span className="text-[13px] text-gray-800">
                  {moment(selectedDoctor.hire_date).format("ll")}
                </span>
              </div>

              <button
                onClick={handleCloseModal}
                className="mt-2 w-full bg-gray-800 hover:bg-gray-700 text-white text-[13px] py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          )}
        </Box>
      </Modal>

    </div>
  );
};

export default Staff;